import { showErrorMessage } from "../commons/show-error-message";
import { newRecurrentSubsidy } from "../../infrastructure/repository/benefit-models-repository";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { getAllowance } from "../../infrastructure/allowance-config-repository";
import { adaptEmployees } from "./performTopUp";
import { showSuccessMessage } from "../commons/show-success-message";
import { displayBenefitPage } from "./displays/display-benefit-page";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

function adaptGeneralParameters(generalParameters) {
  const generalParams = [
    {
      category: "meal-benefit",
      amount: {
        amountInCents: Math.round(generalParameters.mealAmount * 100),
        currency: "EUR",
      },
      days: generalParameters.mealDays,
    },
    {
      category: "transport-benefit",
      amount: {
        amountInCents: Math.round(generalParameters.transportAmount * 100),
        currency: "EUR",
      },
      days: 1,
    },
    {
      category: "nursery-benefit",
      amount: {
        amountInCents: Math.round(generalParameters.nurseryAmount * 100),
        currency: "EUR",
      },
      days: 1,
    },
  ];

  return generalParams;
}

export async function saveRecurrentSubsidy({ model, confirmationRequired }) {
  try {
    const companyId = await findCompanyId();
    const { generalParameters, employeesItems, employeeIds } = getAllowance();
    const employees = adaptEmployees(employeesItems, employeeIds);
    const generalParams = adaptGeneralParameters(generalParameters);

    await newRecurrentSubsidy({
      companyId,
      model,
      employees,
      confirmationRequired,
      generalParameters: generalParams,
    });

    window.location.href = "/benefits";

    addContextLog("info", "saveRecurrentSubsidy", "request", {
      companyId,
      model: model.id,
    });
    showSuccessMessage(translate("common-messages.basic-success-message"));
  } catch (e) {
    logError(e, `Error to saveRecurrentSubsidy in model ${model.id}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
